class UploadDynamic {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }

    init() {
        this.actionAdd = null
        this.element = null
        this.url = null
        this.file = this.initFormUpload()
        this.file.addEventListener('change', () => {
            if (!this.url) {
                return
            }
            this.upload(this.url, this.file.files[0])
        }, false)

        document.addEventListener('click', function (e) {
            if (!e.target.closest('[data-upload-dymanic-add]')) {
                return
            }

            e.preventDefault()

            this.actionAdd = e.target.closest('[data-upload-dymanic-add]')
            this.element = e.target.closest('[data-upload-dymanic]')
            this.url = this.element.dataset.uploadDymanic
            this.file.click()
        }.bind(this), false);

        document.addEventListener('click', function (e) {
            if (!e.target.closest('[data-upload-dynamic-item]')) {
                return
            }

            e.preventDefault()
            e.target.closest('[data-upload-dynamic-item]').remove()
        }.bind(this), false);
    }

    initFormUpload() {
        const form = document.createElement('form')
        form.style.display = 'none'
        form.innerHTML = '<input accept="image/png, image/gif, image/jpeg" id="file-upload-dynamic" type="file" />'
        document.body.appendChild(form)
        return form.querySelector('input[type="file"]')
    }

    upload(url, file) {
        const data = new FormData();
        data.append('file', file);
        fetch(url,
            {
                method: 'POST',
                body: data
            })
            .then((response) => {
                return response.json();
            })
            .then((file) => {
                console.log(file)
                this.showImage(file.id, file.url)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    showImage(id, url) {
        if (undefined == id || undefined == url) {
            return
        }
        const html = '<div class="item-sk" data-upload-dynamic-item=""><input type="hidden" value="' + id + '" name="photo[]" /><img class="img img-xpto2" src="' + url + '"></div>'
        const el = document.createElement('template')
        el.innerHTML = html
        this.element.insertBefore(el.content, this.actionAdd)
    }
}

export default UploadDynamic